import { render, staticRenderFns } from "./NianDuTang.vue?vue&type=template&id=5b54cbe2&scoped=true&"
import script from "./NianDuTang.vue?vue&type=script&lang=js&"
export * from "./NianDuTang.vue?vue&type=script&lang=js&"
import style0 from "./NianDuTang.vue?vue&type=style&index=0&id=5b54cbe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b54cbe2",
  null
  
)

export default component.exports